import DateTitle from './date-title';

export default DateTitle;
